import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import Swal from 'sweetalert2';
import DEFAULT_IMG from '../../assets/img/theme/picture-default.jpeg';
import Input from 'components/input/input';
import { NotesService } from 'services';

const NotesModal = ({ isOpen, onClose, onAdd, note }) => {
  const [title, setTitle] = useState('')
  const [url, setUrl] = useState('')
  const [avatarFile, setAvatarFile] = useState(null)
  const [avatarPreview, setAvatarPreview] = useState(DEFAULT_IMG)
  const [errors, setErrors] = useState('')
  const [isUpload, setIsUpload] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setTitle('')
      setUrl('')
      setAvatarFile(null)
      setAvatarPreview(DEFAULT_IMG)
      setErrors('')
    }
  }, [isOpen])

  useEffect(() => {
    if (note) {
      console.log('useEffect Note:', note)
      setTitle(note.title)
      setUrl(note.url)
      setAvatarFile(null)
      setAvatarPreview(note.url_photo)
      setErrors('')
    }
  }, [note])
  
  

  const changeAvatarFileHandler = (e) => {
    e.preventDefault();
    let file = e.target.files[0];

    if (file) {
      let preview = URL.createObjectURL(file);

      setAvatarFile(file)
      setAvatarPreview(preview)
      // if (this.props.onChangeAvatar) {
      //   this.props.onChangeAvatar(file);
      // }
    }
  }

  const selectFileHanlder = () => {
    document.getElementById('avatarProfile').click();
  }

  const submitImageHandle = () => {
    console.log('save image')
    if (!validateURL(url)) {
      setErrors('Ingrese un link valido')
    } else if (!note && title && url && avatarFile) {
      setErrors('')
      saveImageHandle() 
    } else if (note && title && url) {
      setErrors('')
      updateNoteHandle()
    } else {
      setErrors('Debe llenar todos los campos')
    }
  }

  const changeInputHandler = (e) => {
    if (e.target.name === 'url') {
      setUrl(e.target.value)
    } else {
      setTitle(e.target.value)
    }
    
  }

  const validateURL = (strUrl) => {
    try {
      new URL(strUrl)
      return true
    } catch (error) {
      return false
    }
  }

  const saveImageHandle = async() => {
    try {
      // const { avatarFile, profile } = this.state;
      if (avatarFile) {
        const formData = new FormData();
        formData.append('photo', avatarFile);
        formData.append('title', title);
        formData.append('url', url);

        setIsUpload(true)
        await NotesService.save(formData);
        setIsUpload(false)
        // return response.data && response.data.status;
        Swal.fire({
          title: 'Imagen Guardada',
          text: 'La imagen se ha agregado a la galería',
          icon: 'success',
        })
        onAdd()
      } 
    } catch (e) {
      console.log(e);
      setIsUpload(false)
      Swal.fire({
        title: 'Error',
        text: 'Ocurrio un error al intentar guardar la imagen',
        icon: 'error',
      })

      onAdd()
    }
  }

  const updateNoteHandle = async() => {
    try {
      // const { avatarFile, profile } = this.state;
      setIsUpload(true)
      await NotesService.update(note._id, { title, url })
      if (avatarFile) {
        const formData = new FormData();
        formData.append('photo', avatarFile);
        formData.append('_id', note._id);

        await NotesService.updatePhoto(formData);
      } 

      setIsUpload(false);
      Swal.fire({
        title: 'Nota actualizada',
        text: 'La información de la nota ha sido actualizada',
        icon: 'success',
      });

      onAdd()
    } catch (e) {
      console.log(e);
      setIsUpload(false)
      Swal.fire({
        title: 'Error',
        text: 'Ocurrio un error al intentar guardar la imagen',
        icon: 'error',
      })

      onAdd()
    }
  }

  return (
    <>
      <Modal 
        isOpen={isOpen} 
        toggle={onClose}
        backdrop={false}
        keyboard={false}
      >
        <ModalHeader>Agregar nueva nota</ModalHeader>
        <ModalBody>
          { errors &&
            <div className="alert alert-danger">{errors}</div>
          }
          <form>
            <input 
              type="file" 
              style={{display: 'none'}}
              id="avatarProfile" 
              accept="image/jpeg, image/png, image/jpg" 
              onChange={ changeAvatarFileHandler } 
            />
            <div className="gallery-preview-image">
              <img src={avatarPreview} alt='preview' />
            </div>
            <div className="text-center mb-4">
              <button 
                type="button" 
                className="btn btn-info"
                onClick={selectFileHanlder}
              >
                Seleccionar imagen
              </button>
            </div>
            <Input 
              label="Título"
              name="title"
              type="text"
              value={title}
              onChange={changeInputHandler}
            />
            <Input 
              label="Link"
              name="url"
              type="text"
              value={url}
              onChange={changeInputHandler}
            />
          </form>
          <div className="mt-5">
            { isUpload  ?
                (<div className="col-2 text-right">
                  <Spinner color="primary">
                    Loading...
                  </Spinner>
                </div>)
                :(<div className="row">
                  <div className="col-6">
                    <button type="button" className="btn btn-block btn-secondary" onClick={onClose}>Cancelar</button> 
                  </div>
                  <div className="col-6">
                    <button type="button" className="btn btn-block btn-primary" onClick={submitImageHandle}>Guardar</button> 
                  </div>
                </div>)
            }
            
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default NotesModal